import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';

const WaterBasinPicture = () => {
  document.title = "Усны сав газрын сэдэвчилсэн зураг";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Усны сав газар" breadcrumbItem="Усны сав газрын сэдэвчилсэн зураг" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <CardTitle tag="h5" className="mb-0 flex-grow-1">Усны сав газрын сэдэвчилсэн зураг</CardTitle>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default WaterBasinPicture;